import { IColumn } from '@fluentui/react';

export const ReleaseColumns: IColumn[] = [
    {
        key: 'releaseId',
        name: 'Release',
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        fieldName: 'releaseName',
    },
    {
        key: 'project',
        name: 'Project',
        minWidth: 160,
        maxWidth: 160,
        isResizable: true,
        fieldName: 'projectName',
    },
    {
        key: 'componentName',
        name: 'Component Name',
        minWidth: 180,
        maxWidth: 180,
        isResizable: true,
        fieldName: 'componentName',
    },
    {
        key: 'service',
        name: 'Service',
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        fieldName: 'serviceName',
    },
    {
        key: 'environments',
        name: 'Environment(s)',
        minWidth: 150,
        maxWidth: 180,
        isResizable: true,
        fieldName: 'environments',
    },
    {
        key: 'deploymentTypes',
        name: 'Deployment Type',
        minWidth: 180,
        maxWidth: 180,
        isResizable: true,
        fieldName: 'deploymentTypes',
    },
    {
        key: 'createdOn',
        name: 'Created On',
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        fieldName: 'createdOn',
    },
    {
        key: 'updatedOn',
        name: 'Last Updated',
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        fieldName: 'updatedOn',
    },
];
